import type { Character } from '@/types';
import { isLocalMode } from '@/local';
import { apiFetch } from './apiBase';
import { localCreateCharacter } from '@/local/localBackend';

export interface CreateCharacterInput {
  name: string;
  type: Character['type'];
  description?: string;
  /** base64 data URL ("data:image/png;base64,…") — optional. */
  imageDataUrl?: string;
}

export async function createCharacter(
  episodeUuid: string,
  body: CreateCharacterInput,
): Promise<Character> {
  if (isLocalMode()) return localCreateCharacter(episodeUuid, body);
  const res = await apiFetch(
    `/api/episode/${encodeURIComponent(episodeUuid)}/v2/characters`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  if (!res.ok) throw new Error(`createCharacter failed: ${res.status}`);
  return res.json();
}
